export interface IOpenCabWorkflow {
    preTripDvirCompleteVehicleId?: string;
    skippedAssetSelection?: boolean;
    userSkippedUnverifiedLogsDate?: IIdDictionary<string>;
    userLastSeenUncertifiedHosNotificationDate?: IIdDictionary<string>;
}

export enum OpenCabWorkflowActionTypes {
    SET_SKIPPED_ASSET_SELECTION = "SET_SKIPPED_ASSET_SELECTION",
    CLEAR_SKIPPED_ASSET_SELECTION = "CLEAR_SKIPPED_ASSET_SELECTION",
    SET_PRE_TRIP_DVIR_COMPLETE_VEHICLE_ID = "SET_PRE_TRIP_DVIR_COMPLETE_VEHICLE_ID",
    CLEAR_PRE_TRIP_DVIR_COMPLETE_VEHICLE_ID = "CLEAR_PRE_TRIP_DVIR_COMPLETE_VEHICLE_ID",
    SET_USER_SKIPPED_UNVERIFIED_LOGS_DATE = "SET_USER_SKIPPED_UNVERIFIED_LOGS_DATE",
    CLEAR_USER_SKIPPED_UNVERIFIED_LOGS_DATE = "CLEAR_USER_SKIPPED_UNVERIFIED_LOGS_DATE",
    SET_USER_LAST_SEEN_UNCERTIFIED_HOS_NOTIFICATION_DATE = "SET_USER_LAST_SEEN_UNCERTIFIED_HOS_NOTIFICATION_DATE",
    CLEAR_USER_LAST_SEEN_UNCERTIFIED_HOS_NOTIFICATION_DATE = "CLEAR_USER_LAST_SEEN_UNCERTIFIED_HOS_NOTIFICATION_DATE"
}